import dynamic from 'next/dynamic';

import LazyHydration from 'components/LazyHydration';
import LoadingBox from 'components/LoadingBox';

import useMediaQuery from 'hooks/useMediaQuery';

const Sidebar = dynamic(() => import('./Sidebar'), {
  ssr: false,
  loading: () => (
    <div className="col-span-4 md:col-span-12 xl:col-span-4">
      <LoadingBox className="h-[800px]" />
    </div>
  ),
});

const DynamicallyLoadedSidebar = ({ gaEventCategory }) => {
  const { isXl } = useMediaQuery();

  const styles =
    'col-span 4 row-start-4 md:col-span-full xl:col-span-4 xl:row-start-3';

  // Dynamically loads a smaller component if the sidebar is not visible
  if (isXl !== null && !isXl) {
    return (
      <LazyHydration placeholderSize={{ height: 1125 }}>
        <Sidebar className={styles} gaEventCategory={gaEventCategory} />
      </LazyHydration>
    );
  }

  return <Sidebar className={styles} gaEventCategory={gaEventCategory} />;
};

export default DynamicallyLoadedSidebar;
